import { appbarHeight, rvh, appbarHeightMobile } from "themes/constants/sizes"
import { masterBreakPoint } from "themes/default/breakpoints"

export const styles = {
  main:
    (showHeader = true) =>
    (theme) => ({
      position: "relative",
      width: "100%",
      height: showHeader ? `calc(${rvh()} - ${appbarHeight}px)` : rvh(),
      minHeight: showHeader ? `calc(${rvh()} - ${appbarHeight}px)` : rvh(),
      top: showHeader ? appbarHeight : 0,
      overflowY: "auto",
      [masterBreakPoint]: {
        height: showHeader ? `calc(${rvh()} - ${appbarHeightMobile}px)` : rvh(),
        minHeight: showHeader
          ? `calc(${rvh()} - ${appbarHeightMobile}px)`
          : rvh(),
        top: showHeader ? appbarHeightMobile : 0,
      },
    }),
}
